import * as Yup from "yup";

export const formValidationSchema = () =>
  Yup.object().shape({
    noCoa: Yup.string().required("Pilih COA"),
  });
